import { SpecialdayOpeningDay } from '@/types/special-opening-day';
import { WeekdayOpeningDay } from '@/types/weekday-opening-day';
import i18n from '@/setup/i18n';

export type FormattedOpeningWeekdaysHours = {
  timeframe?: string;
  openingTime?: string;
}

/**
 * Returnes an an array of objects with the weekday and opening hours/closed.
 */
export default function getFormattedOpeningWeekdaysHours(openingHours: (WeekdayOpeningDay | SpecialdayOpeningDay)[])
  : FormattedOpeningWeekdaysHours[] | undefined {
  if (!openingHours) {
    return undefined;
  }

  return openingHours.map((day) => {
    let timeframe: string | undefined;

    if ('weekDay' in day) {
      timeframe = day.weekDay;
    } else if ('formattedDate' in day) {
      timeframe = day.formattedDate;
    }

    if (!day.closed) {
      const {
        openingTime,
        closingTime,
        openingTime2,
        closingTime2,
      } = day;

      const parts = [];

      if (openingTime?.formattedHour && closingTime?.formattedHour) {
        parts.push(`${openingTime.formattedHour}-${closingTime.formattedHour}`);
      }

      if (openingTime2?.formattedHour && closingTime2?.formattedHour) {
        parts.push(`${openingTime2.formattedHour}-${closingTime2.formattedHour}`);
      }

      if (parts.length) {
        return {
          timeframe,
          openingTime: parts.join(' / '),
        };
      }
    }

    return {
      timeframe,
      openingTime: i18n.global.t('global.closedAllDay'),
    };
  });
}
